export default __webpack_public_path__ + "static/media/012-snowflake.05bde860.svg";